import { m } from '@hub/messages';
import { Button, Icon, useCopyToClipboard } from '@platform/ui';

interface ErrorToastDescriptionProps {
  eventId: string;
}

export function ErrorToastDescription({ eventId }: ErrorToastDescriptionProps) {
  const { status, copy } = useCopyToClipboard();
  const shortId = eventId.slice(0, 8);

  const ariaLabel = m.commons_error_toast_copy_label({ status });
  const iconName = status === 'copied' ? 'check' : status === 'failed' ? 'close' : 'copy';

  return (
    <span className="inline-flex items-center gap-1">
      <span>{m.commons_error_reference({ eventId: shortId })}</span>
      <Button type="button" variant="plain" size="icon" iconOnly onClick={() => copy(eventId)} aria-label={ariaLabel}>
        <Icon name={iconName} size="lg" />
      </Button>
    </span>
  );
}
